import { useParams } from 'react-router-dom';

import { getApproveForm } from './ApprovalFormResolverMapper';
import { RequestTypeId } from './types';

const ApprovalFormResolver: React.FC = () => {
  const { requestTypeId } = useParams<{
    requestTypeId: RequestTypeId;
  }>();

  return <div>{getApproveForm(requestTypeId!)}</div>;
};

export default ApprovalFormResolver;
